import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4 bg-gray-50 overflow-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "prose px-6 pt-5 text-sm text-gray-400 cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-secondary [&>a]:no-underline [&>a]:text-secondary" }, [
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Mobiliseringer"),
    /*#__PURE__*/_createTextVNode(" / Min plan ")
  ])
], -1)
const _hoisted_3 = { class: "bg-white px-6 py-5 text-gray-400" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "flex-auto font-semibold text-gray-900" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Forrige måned", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Næste måned", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "mt-10 grid grid-cols-7 text-center text-sm font-bold leading-6 text-gray-900" }
const _hoisted_13 = { class: "isolate mt-2 grid grid-cols-7 gap-px bg-gray-200 text-sm shadow ring-1 ring-gray-200" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["datetime"]
const _hoisted_16 = { class: "absolute top-0 left-0 w-full h-full flex flex-row gap-x-[2px] items-end justify-center pb-1" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "text-xl font-medium text-secondary pb-4" }
const _hoisted_20 = {
  role: "list",
  class: "divide-y divide-gray-200 border-y border-gray-200 p-0"
}
const _hoisted_21 = { class: "m-0 flex justify-between p-0" }
const _hoisted_22 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Site", -1)
const _hoisted_24 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_25 = { class: "m-0 flex justify-between p-0" }
const _hoisted_26 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Arb. art", -1)
const _hoisted_28 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_29 = { class: "m-0 flex justify-between p-0" }
const _hoisted_30 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Fra dato", -1)
const _hoisted_32 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_33 = { class: "m-0 flex justify-between p-0" }
const _hoisted_34 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Til dato", -1)
const _hoisted_36 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_37 = { class: "m-0 flex justify-between p-0" }
const _hoisted_38 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Lønlinjer udspecificeret", -1)
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 0,
  class: "m-0 flex flex-row pb-2 pt-2"
}
const _hoisted_42 = { class: "m-0" }
const _hoisted_43 = {
  class: "m-0",
  style: {"margin-left":"5px"}
}
const _hoisted_44 = {
  key: 1,
  class: "text-base font-light text-blue-900"
}
const _hoisted_45 = {
  key: 1,
  class: "text-base font-light text-blue-900"
}
const _hoisted_46 = {
  key: 1,
  class: "bg-white px-6 py-5 text-sm text-gray-400 mb-12"
}
const _hoisted_47 = { class: "text-xl font-medium text-secondary pb-4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Der er ingen mobiliseringer på denne dag.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_adjust_height = _resolveDirective("adjust-height")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.currentDateDisplay), 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousMonth && _ctx.previousMonth(...args))),
          type: "button",
          class: "-my-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500"
        }, _hoisted_8),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args))),
          type: "button",
          class: "-my-1.5 -mr-1.5 ml-2 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500"
        }, _hoisted_11)
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (weekDay) => {
          return (_openBlock(), _createElementBlock("div", { key: weekDay }, _toDisplayString(weekDay), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysForGrid, (day) => {
          return (_openBlock(), _createElementBlock("button", {
            key: day.date.toString(),
            class: _normalizeClass(["relative h-10 focus:z-10", _ctx.isSelectedDay(day.date)
            ? 'bg-secondary text-white'
            : (day.isCurrentMonth ? 'bg-white text-gray-900' : 'bg-gray-50 text-gray-400')]),
            onClick: ($event: any) => (_ctx.setSelectedDay(day.date)),
            type: "button"
          }, [
            _createElementVNode("time", {
              datetime: day.date.toISOString(),
              class: _normalizeClass(["mx-auto flex h-7 w-7 items-center justify-center rounded-full", day.date.getDate() === new Date().getDate() && day.date.getMonth() === new Date().getMonth() ? 'font-semibold' : ''])
            }, _toDisplayString(day.date.getDate()), 11, _hoisted_15),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDotCount(day.date), (dotIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: dotIndex,
                  class: "w-1 h-1 rounded-full bg-orange-600"
                }))
              }), 128))
            ])
          ], 10, _hoisted_14))
        }), 128))
      ])
    ]),
    (_ctx.selectedDay)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          (_ctx.mobilizationDetails && _ctx.mobilizationDetails.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mobilizationDetails, (detail, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "bg-white px-6 py-5 text-sm text-gray-400 mb-12"
                  }, [
                    _createElementVNode("h1", _hoisted_19, _toDisplayString(_ctx.displayFormattedDate(_ctx.selectedDay)), 1),
                    _createElementVNode("ul", _hoisted_20, [
                      _createElementVNode("li", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, _toDisplayString(detail.siteName) + " - " + _toDisplayString(detail.kundeNavn), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("div", _hoisted_28, _toDisplayString(detail.workType), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.displayFormattedDate(detail.departureDate)), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.displayFormattedDate(detail.returnDate)), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          (detail.salary && detail.salary.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.salary, (salary, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "text-base font-medium leading-5 text-gray-800"
                                  }, [
                                    (salary.antal !== 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                          _createElementVNode("div", _hoisted_42, _toDisplayString(salary.timetype) + ":", 1),
                                          _createElementVNode("div", _hoisted_43, _toDisplayString(Number(salary.antal).toLocaleString()) + " timer", 1)
                                        ]))
                                      : (salary.antal === 0 && detail.salary.length == 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, "Der er ingen lønlinjer på denne dag."))
                                        : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (!detail.salary || detail.salary.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, "Der er ingen lønlinjer på denne dag."))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _createElementVNode("h1", _hoisted_47, _toDisplayString(_ctx.displayFormattedDate(_ctx.selectedDay)), 1),
                _hoisted_48
              ]))
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_adjust_height]
  ])
}